module.exports = __webpack_public_path__ + "static/Q1_2024_Investor_call_Dial-in_information-6d58ee349ea77a0d21b8001ceca17765.pdf";